import Image, { type ImageProps } from 'next/image'
import type { CardArtAssetName } from '../../types'
import { blurDataUrls } from '../../../constants/blurDataUrls'
import { CDN_BASE_URL } from '../../../constants/contentUrls'

interface MLVisaCardImageProps extends Omit<ImageProps, 'src' | 'alt'> {
  cardArt?: CardArtAssetName | null // use custom prop instead of src because src is not optional
}

const MLVisaCardImage = (props: MLVisaCardImageProps) => {
  const { cardArt = 'greenlineV0', ...rest } = props

  // handle possible null value
  const cardArtId = cardArt ?? 'greenlineV0'

  return (
    <Image
      data-testid="ml-visa-card"
      src={`${CDN_BASE_URL}/images/card-art/${cardArtId}.svg`}
      alt="Mission Lane Visa card"
      quality={100}
      placeholder="blur"
      blurDataURL={blurDataUrls[cardArtId]}
      className="rounded-[3%/5%] shadow-card h-auto"
      {...rest}
    />
  )
}

export default MLVisaCardImage
